import { DASHBOARD_ROUTE } from './common';
import Dashboard from './dashboard/index';

export default {
    [DASHBOARD_ROUTE]: () => <Dashboard />,
};
